import React, {useRef, useEffect, useState} from 'react';
import { FormFeedback, FormGroup, Label } from "reactstrap";
import { FieldProps } from 'formik'

import FormikFieldCustomProps from "../field/formikfieldcustomprops";



const QuestionInput: React.FC<FormikFieldCustomProps & FieldProps & {
  index: number;
  questionCount: number;
}> = ({
  field: { ...fields },
  form: { touched, errors, ...rest },
  ...props
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [text, setText] = useState("");
  const [textAreaHeight, setTextAreaHeight] = useState("auto");
  useEffect(() => {
		setTextAreaHeight(`${textAreaRef.current!.scrollHeight + 14}px`);
  }, [text]);
  const onChangeHandler = (event: any) => {
		setTextAreaHeight("auto");
		setText(event.target.value);

		if (textAreaRef.current && textAreaRef.current.onchange) {
			textAreaRef.current.onchange(event);
		}
	};
  return (
    <FormGroup className="question-input">
      <Label for={fields.name} className={"label-color"}>
        <span className="question-count">{props.index + 1}/{props.questionCount}</span>
        <textarea
          className="form-control"
          ref={textAreaRef}
          autoFocus={props.index === props.questionCount-1}
          {...props}
          {...fields}
          style={{
            height: textAreaHeight,
          }}
          rows={1}
          onChange={e => {
            fields.onChange(e)
            onChangeHandler(e)
          }}/>
        {touched[fields.name] && errors[fields.name] ? <FormFeedback>{errors[fields.name]}</FormFeedback> : ''}
      </Label>
    </FormGroup>
  );
}


export default QuestionInput;
